<template>
  <div class="page">
    <div class="topbox clearfix">
      <div class="bigpicstyle">
        <!-- 添加就诊卡开始 -->
        <div class="topboxcon" v-show="active">
          <span class="block">
            <img src="../../assets/images/addcard.png" alt class="nonenum" />
          </span>
          <span class="block addguide">挂号请添加就诊卡</span>
          <span class="addCardBtn" @click="addcard">
            <img src="../../assets/images/addpic.png" alt />
            <span>添加就诊卡</span>
          </span>
        </div>
        <!-- 添加就诊卡结束 -->
        <div class="topboxcon" v-show="!active">
          <div class="cardinfo clearfix">
            <div class="homecode">
              <img class="twocode" :src="headimgurl" alt />
              <span class="codeexplan"></span>
            </div>
            <div class="homecode codeinfo clearfix">
              <p>{{userinfo.Name}}&nbsp;&nbsp;&nbsp;{{userinfo.Sex}}</p>
              <P>档案号：{{userinfo.PatNo}}</P>
              <img
                class="codeImgStyle"
                @click="ShowCode(userinfo)"
                src="../../assets/images/twocode.png"
              />
            </div>
          </div>
          <!-- <div class="cut" @click="swith">
            <img src="../../assets/images/qiehuan.png" class="qiehuan" alt />
            <span>切换就诊卡</span>
          </div> -->
        </div>
      </div>

      <div class="banner-box">
        <div class="banner bannerbg1" @click="registerfun">
          <div>
            <p class="block">预约挂号</p>
            <p class="sammllcon1">预约号源</p>
            <p>
              <img src="../../assets/images/arrows.png" alt class="arrows" />
            </p>
          </div>
        </div>
        <div class="banner marginleft bannerbg2" @click="payfun">
          <div>
            <p class="block">门诊缴费</p>
            <p class="sammllcon2">在线缴费</p>
            <p>
              <img src="../../assets/images/arrows.png" alt class="arrows" />
            </p>
          </div>
        </div>
      </div>
      <div class="banner-box" style="padding: 0 0.2rem 0.2rem 0.2rem;">
        <div class="banner bannerbg3" @click="IpPaymentfun">
          <div>
            <p class="block">住院预交金</p>
            <p class="sammllcon3">在线充值</p>
            <p>
              <img src="../../assets/images/arrows.png" alt class="arrows" />
            </p>
          </div>
        </div>
        <div class="banner marginleft bannerbg4" @click="IpListfun">
          <div>
            <p class="block">预交金查询</p>
            <p class="sammllcon4">在线查询</p>
            <p>
              <img src="../../assets/images/arrows.png" alt class="arrows" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="list clearfix">
      <ul class="clearfix">
        <li @click="waiting">
          <div>
            <img src="../../assets/images/pic1.png" alt />
          </div>
          <div>
            <p>候诊签到</p>
            <p>查询当前等待时间</p>
          </div>
        </li>
        <li @click="reportfun">
          <div>
            <img src="../../assets/images/pic2.png" alt />
          </div>
          <div>
            <p>报告查询</p>
            <p>查看检查检验评定报告</p>
          </div>
        </li>
        <li @click="treatmentFun">
          <div>
            <img src="../../assets/images/pic3.png" alt />
          </div>
          <div>
            <p>治疗计划</p>
            <p>查看治疗进度</p>
          </div>
        </li>
        <li @click="centerFun">
          <div>
            <img src="../../assets/images/pic4.png" alt />
          </div>
          <div>
            <p>个人中心</p>
            <p>查看就诊记录等</p>
          </div>
        </li>
        <li @click="satisFun">
          <div>
            <img src="../../assets/images/pic5.png" alt />
          </div>
          <div>
            <p>满意度调查2324</p>
            <p>收集反馈意见</p>
          </div>
        </li>
        <!-- <li @click="testFun">
            <div>
            <img src="../../assets/images/pic5.png" alt />
          </div>
          <div>
            <p>测试</p>

            <p>测试效果</p>
          </div>
        </li> -->
      </ul>
    </div>

    <!-- 遮罩弹窗 -->
    <div class="popContainer" v-show="codeIsShow">
      <div class="popcon">
        <div class="topbig"></div>
        <div class="popdeteil">
          <p>{{userinfo.Name}}&nbsp;&nbsp;&nbsp;{{userinfo.Sex}}&nbsp;&nbsp;&nbsp;{{userinfo.StrAge}}</p>
          <p>{{userinfo.PatNo}}&nbsp;&nbsp;&nbsp;{{userinfo.CardNo}}</p>
          <img src="../../assets/images/codedel.png" alt class="codedel" @click="codedelfun" />
        </div>
        <div class="popcode">
          <div>
            <img :src="CodeImgUrl" alt />
          </div>
          <!-- <p>请凭此二维码到签到台签到</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetOpenId,
  GetAllCardByOpenID,
  SetItem,
  RemoveItem,
  GetAuthorizeUrl,
  GetItem,
  GetWXUserInfo,
  GetPayData,
} from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "home",
  data() {
    return {
      active: true,
      isshow: false,
      userinfo: {},
      headimgurl: "",
      CodeImgUrl: "",
      codeIsShow: false,
      hre: '',
    };
  },
  created: function() {
    this.active = false;
    this.getOpenId();
  },
  methods: {
    swith() {
      if (GetItem("hosid") == null) {
        this.$router.push({ path: "/home/choose", query: { source: 0 } });
      } else {
        //跳转到切换就诊人页
        this.$router.push({ path: "/card/switchcard" });
      }
    },
    addcard() {
      //跳转到添加就诊卡页
      if (GetItem("hosid") == null) {
        this.$router.push({ path: "/home/choose", query: { source: 0 } });
      } else {
        this.$router.push({ path: "/card/addcard", query: { active: true } });
      }
    },
    isshowfun() {
      this.isshow = !this.isshow;
    },
    ShowCode(item) {
      console.log("item....", item);
      this.CodeImgUrl =
        "http://qr.liantu.com/api.php?&w=200&text=" + item.PatNo;
      this.codeIsShow = true;
    },
    codedelfun() {
      this.codeIsShow = false;
    },
    registerfun() {
      //跳转到预约挂号(选择院区)
      this.$router.push({ path: "/home/choose" });
    },
    isGoAddcard() {
      var _that = this;
      weui.dialog({
        content: "请先添加就诊卡，需实名认证后方可使用此功能",
        className: "custom-classname",
        buttons: [
          {
            label: "取消",
            type: "default",
            onClick: function() {}
          },
          {
            label: "去添加",
            type: "primary",
            onClick: function() {
              _that.addcard();
            }
          }
        ]
      });
    },
    payfun() {
      //跳转到门诊缴费
      if (GetItem("patid") == null) {
        this.isGoAddcard();
      } else {
        this.$router.push({
          path: "/pay/outpatienthome",
          params: { userId: 123 }
        });
      }
    },
    IpPaymentfun() {
      if (GetItem("hosid") == null) {
        this.$router.push({ path: "/home/choose", query: { source: 3 } });
      } else if (GetItem("patid") == null) {
        this.isGoAddcard();
      } else {
        // 跳转到预交金充值页面
        this.$router.push({ path: "/IpPayment/IpPayment" });
      }
    },
    IpListfun() {
      if (GetItem("patid") == null) {
        this.isGoAddcard();
      } else {
        // 跳转到住院预交金
        this.$router.push({ path: "/IpPayment/IpList" });
      }
    },
    waiting() {
      //跳转到候诊无卡添加卡
      //  this.$router.push({ path: "/waiting/nocard", params: {} });
      //跳转到候诊信息页
      //跳转到门诊缴费
      if (GetItem("patid") == null) {
        this.isGoAddcard();
      } else {
        this.$router.push({ path: "/waiting/waitinformation", params: {} });
      }
    },
    reportfun() {
      //跳转到报告查询
      if (GetItem("patid") == null) {
        this.isGoAddcard();
      } else {
        window.location.href = "http://www.igosun.cn/weiXin/QueryReport.html"
        // this.$router.push({ path: "/report/query", params: {} });
      }
    },
    satisFun() {
      //跳转到满意度查询
      if (GetItem("patid") == null) {
        this.isGoAddcard();
      } else {
        this.$router.push({ path: "/satisfaction/query", params: {} });
      }
    },
    centerFun() {
      //跳转到个人中心
      if (GetItem("patid") == null) {
        this.isGoAddcard();
      } else {
        this.$router.push({ path: "/person/center", params: {} });
      }
    },
    treatmentFun() {
      //跳转到治疗计划
      if (GetItem("patid") == null) {
        this.isGoAddcard();
      } else {
        this.$router.push({ path: "/treatment/treatmentplan", params: {} });
      }
    },
    getWXUserInfo() {
      GetWXUserInfo().then(response => {
        this.headimgurl = response.data.headimgurl;
      });
    },
    getAllCardByOpenID() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      var _that = this;
      GetAllCardByOpenID().then(response => {
        loading.hide();
        if (response.data) {
          if (response.data.length > 0) {
            _that.getWXUserInfo();
            response.data.forEach(function(item) {
              if (item.Default) {
                _that.active = false;
                _that.userinfo = item;
                _that.$store.commit("setUserInfo", item);
                SetItem("patid", item.PatID);
              }
            });
          } else {
            this.active = true;
          }
        } else {
          this.active = true;
        }
      });
    },
    getOpenId() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      var code = this.getUrlCode().code;
      if (code) {
        if (GetItem("openid") == null) {
          //获取到code以查找openid
          GetOpenId(code).then(response => {
            SetItem("openid", response.data);
            this.getAllCardByOpenID();
          });
        } else {
          this.getAllCardByOpenID();
        }
      } else {
        RemoveItem("openid");
        RemoveItem("patid");
        RemoveItem("APPSTATE");
        RemoveItem("hosid");
        RemoveItem("backNumberTime");
        GetAuthorizeUrl("")
          .then(response => {
            window.location.replace(response.data);
          })
          .catch(function(err) {});
      }
    },
    // getOpenId() {
    //   //获取到code以查找openid
    //   SetItem("openid", "oeg2H0yZOHAuISnmzWSZVamy8JwE");
    //   this.getAllCardByOpenID();
    // },
    getUrlCode() {
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    }
  }
};
</script>

<style scoped>
.topbox {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.topbox .bigpicstyle {
  background: url("../../assets/images/beijing.png") no-repeat, #fff;
  background-size: 100% 66%;
}

.topboxcon {
  flex: 1;
  overflow: hidden;
  margin: 0.2rem;
  border: 0.4rem;
  border-color: #dddddd;
  /* height: 2.4rem; */
  text-align: center;
  background-color: white;
  color: #3d97d1;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  position: relative;
  box-shadow: 0 0.03rem 0.08rem 0 rgba(200, 214, 223, 1);
  border-radius: 0.08rem;
}

.block {
  display: block;
}

.topboxcon .nonenum {
  width: 0.81rem;
  height: 0.81rem;
  margin-top: 0.3rem;
  margin-left: 42.5%;
  margin-bottom: 0.1rem;
}

.banner-box {
  padding: 0.2rem;
  width: 100%;
  display: flex;
  background-color: white;
  box-sizing: border-box;
}

.banner {
  display: inline-block;
  width: 49%;
  height: 1.6rem;
  background-color: rgba(248, 248, 248, 1);
  /* color: white; */
}

.banner > div {
  padding-left: 0.27rem;
}

.banner > div > p:first-child {
  font-size: 0.28rem;
  color: #fffeff;
  margin-top: 0.32rem;
}

.banner .sammllcon1 {
  font-size: 0.2rem;
  color: #ffe193;
}

.banner .sammllcon2 {
  font-size: 0.2rem;
  color: #baeaff;
}

.banner .sammllcon3 {
  font-size: 0.2rem;
  color: #a2ea9d;
}

.banner .sammllcon4 {
  font-size: 0.2rem;
  color: #fec7d5;
}

.bannerbg1 {
  background-image: url("../../assets/images/bg1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.bannerbg2 {
  background-image: url("../../assets/images/bg2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.bannerbg3 {
  background-image: url("../../assets/images/bg3.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.bannerbg4 {
  background-image: url("../../assets/images/bg4.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.marginleft {
  margin-left: 0.2rem !important;
}

.banner img {
  display: block;
  width: 0.71rem;
  height: 0.71rem;
  margin-top: 0.28rem;
  margin-left: 1.05rem;
}

.arrows {
  display: inline-block;
  width: 0.29rem !important;
  height: 0.29rem !important;
  margin-top: 0.08rem !important;
  margin-left: 0 !important;
}

.list {
  width: 100%;
  margin-top: 0.2rem;
}

.list img {
  width: 0.6rem;
  height: 0.6rem;
  margin-left: 0.28rem;
  margin-right: 0.21rem;
}

.list ul {
  margin: 0;
  padding: 0;
}

.list ul li {
  list-style: none;
  float: left;
  width: 50%;
  height: 0.9rem;
  background: white;
  border-bottom: 0.01rem solid #f2f2f2;
  padding-top: 0.35rem;
  position: relative;
}

.list ul li::after {
  content: "";
  display: block;
  border: 0.01rem solid #f2f2f2;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.list ul li > div {
  display: inline-block;
}

.list ul li > div > p:first-child {
  font-size: 0.26rem;
  color: #333333;
  margin-top: 0.35rem;
  margin-bottom: 0.15rem;
  margin: 0;
}

.list ul li > div > p:last-child {
  font-size: 0.19rem;
  color: #999999;
  margin: 0;
}

/* 有卡样式 */
.card {
  margin: 0.625rem;
  border: 0.0625rem;
  border: 0.4rem;
  border-color: #dddddd;
  border-radius: 0.1875rem;
  box-shadow: 0.1875rem, 0.1875rem, 0.625rem, #c8d6df;
  width: 18.75rem;
  height: 7.5rem;
  background-color: white;
  font-family: "MicrosoftYaHei";
  position: relative;
}

.cardinfo {
  padding-left: 0.38rem;
  padding-bottom: 0.28rem;
  border-bottom: 0.01rem dotted #dcdcdc;
}

.topboxcon .twocode {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  /* margin-left: 0.38rem; */
  margin-top: 0.33rem;
  margin-right: 0.29rem;
  position: relative;
  border-radius: 0.15rem;
}

.topboxcon .codeexplan {
  position: absolute;
  font-size: 0.16rem;
  color: #333333;
  left: 0.25rem;
}

.codeinfo > p:first-child {
  color: #333333;
  font-size: 0.3rem;
  text-align: left !important;
  margin-top: 0.42rem;
}

.codeinfo > p:last-child {
  color: #999999;
  font-size: 0.3rem;
  text-align: left !important;
}

.page .topboxcon .cut {
  box-sizing: border-box;
  padding-top: 0.15rem;
}

.qiehuan {
  width: 0.32rem;
  height: 0.32rem;
  display: inline-block;
  vertical-align: text-bottom;
}

.clearfix {
  /* overflow: auto; */
  zoom: 1;
}

.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
  zoom: 1;
  overflow: auto;
}

.page .homecode {
  float: left;
}
.codeImgStyle {
  width: 30px;
  position: absolute;
  right: 10px;
  top: 32px;
}

/* 遮罩弹窗样式 */
/* div.popContainer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .popContainer .popcon {
    width: 3.5rem;
    height: 1.5rem;
    background-color: white;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -1.75rem;
    margin-top: -0.75rem;
    border-radius: 0.04rem;
    font-size: 0.24rem;
  }

    .popContainer .popcon .popguide {
      padding: 0.2rem;
      box-sizing: border-box;
      position: relative;
    }

    .popContainer .popcon .guidePic {
      height: 3rem;
      width: 1rem;
      margin-top: -3rem;
      margin-left: 1rem;
    }

    .popContainer .popcon .sure {
      text-align: right;
      color: #1592E4;
    }

    .popContainer .popcon .popguide > div:first-child {
      height: 0.65rem;
    }

    .popContainer .popcon .popguide > div:last-child {
      line-height: 0.5rem;
      text-align: center;
    } */

/* 遮罩弹窗样式 */
div.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.popContainer .popcon {
  width: 4.19rem;
  height: 5.21rem;
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -2.08rem;
  margin-top: -2.605rem;
}

.popContainer .popcon .topbig {
  width: 100%;
  height: 0.1rem;
  background-color: #1592e4;
}

.popContainer .popcon .popdeteil {
  padding-left: 0.28rem;
  padding-top: 0.23rem;
  font-size: 0.24rem;
  color: #333333;
  border-bottom: 0.01rem solid #dcdcdc;
  padding-bottom: 0.19rem;
  font-family: "MicrosoftYaHei";
}

.popContainer .popcon .popdeteil .codedel {
  position: absolute;
  width: 0.42rem;
  height: 0.42rem;
  right: 0.2rem;
  top: 0.2rem;
}

.popContainer .popcon .popcode {
  text-align: center;
  font-size: 0.2rem;
  color: #333333;
  padding: 0.32rem 0.64rem 0.1rem 0.63rem;
}

.popContainer .popcon .popcode img {
  display: inline-block;
  width: 2.92rem;
  height: 2.92rem;
}

.topboxcon .addCardBtn {
  padding: 0.02rem 0.2rem;
  border: 0.01rem solid #1592e4;
  box-sizing: border-box;
}

.topboxcon .addCardBtn > img {
  display: inline-block;
  width: 0.2rem;
  height: 0.18rem;
}

.topboxcon .addguide {
  color: #999999;
  font-size: 0.22rem;
  margin-bottom: 0.12rem;
}

/* 遮罩弹窗样式 结束*/
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue